import api from "@api";

export default {
  namespaced: true,
  state: {
    homeDto: {
      netProfit: 0,
      currentBalance: 0,
      totalCodesCount: 0
    },
    chartDto: {
      monthlyCodeSales: []
    }
  },
  mutations: {
    SET_HOME_DTO(state, payload) {
      state.homeDto = { ...state.homeDto, ...payload }
    },
    SET_CHART_DTO(state, payload) {
      state.chartDto = { ...state.chartDto, ...payload }
    }
  },
  actions: {
    getHomeDash({ commit }, year) {
      api.get(
        'Home/Dash/GetTeacherProfit',
        ({ data }) => {
          commit('SET_HOME_DTO', data)
        },
        (error) => {
          console.error('❌ خطأ في جلب بيانات الأرباح:', error)
        },
        { params: { year } }
      )
    },
    getCharts({ commit }, year) {
      api.get(
        'Home/Dash/GetCodeSales',
        ({ data }) => {
          commit('SET_CHART_DTO', data)
        },
        (error) => {
          console.error('❌ خطأ في جلب بيانات مبيعات الأكواد:', error)
        },
        { params: { year } }
      )
    }
  }
}
